export { readFromEnv, readFullEnv } from './lib'
export {
  Env,
  type IEnvironment,
  type IEnvironmentFromFile,
  type keys,
} from './lib'
